import {
  TERMINAL_MANUAL_ENABLED_CLEAN_REQUEST,
  TERMINAL_MANUAL_ENABLED_FETCH_REQUEST,
  TERMINAL_MANUAL_ENABLED_FETCH_REQUEST_FAILURE,
  TERMINAL_MANUAL_ENABLED_FETCH_REQUEST_SUCCESS,
} from 'constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const terminalManualEnabledReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_MANUAL_ENABLED_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_MANUAL_ENABLED_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case TERMINAL_MANUAL_ENABLED_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_MANUAL_ENABLED_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default terminalManualEnabledReducer;
